import React, { useState } from "react";
import Layout from "../../../components/Layout/Layout";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import InputField from "../../../components/UI/Forms/InputField";
import ErrorMessage from "../../../components/UI/Notifications/ErrorMessage";
import Button from "../../../components/UI/Buttons/Button";
import { showToastNotification } from "../../../utility/helper";
import { callApi } from "../../../api/callApi";
import { API_ENDPOINT, API_URL_2 } from "../../../api/constant";


const AddPage: React.FC = () => {
    const { register, handleSubmit, formState: { errors } } = useForm({ mode: 'onBlur' });
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false)
    const onSubmit = async (data: any) => {
        setLoading(true)
        try {
            await callApi(API_URL_2 + API_ENDPOINT.page + 'pages', { method: 'POST', data: data })
            setLoading(false);
            navigate('/pages')
        } catch (error: any) {
            setLoading(false)
            showToastNotification('danger', error.message)
        }
    }
    return (
        <Layout>
            <h1 className="app-page-title">Add Page</h1>
            <div className="app-card app-card-settings shadow-sm p-4">
                <div className="app-card-body">
                    <form onSubmit={handleSubmit(onSubmit)} >
                        <div className="row">
                            <div className="mb-3 col-12 col-md-6">
                                <InputField
                                    type="text"
                                    register={register('slug', { required: 'Navigation Link is required' })}
                                    name="slug"
                                    label="Navigation Link"
                                />
                                <ErrorMessage message={errors.slug?.message?.toString()} />
                            </div>
                            <div className="mb-3 col-12 col-md-6">
                                <InputField
                                    type="text"
                                    register={register('title', { required: 'Page Title is required' })}
                                    name="slug"
                                    label="Page Title"
                                />
                                <ErrorMessage message={errors.title?.message?.toString()} />
                            </div>
                            <div className="mb-3 col-12 ">
                                <label className="form-label">Meta Description</label>
                                <textarea {...register('meta_description', { required: 'Meta Description is required' })} className="form-control" rows={2} defaultValue={""} />
                                <ErrorMessage message={errors.meta_description?.message?.toString()} />
                            </div>
                            <div className="col-12">
                                <Button loading={loading} className="app-btn-primary" type="submit" text="Save" />
                            </div>
                        </div>
                    </form>
                </div>
                {/*//app-card-body*/}
            </div>
        </Layout>
    )
}

export default AddPage